import React, { ReactNode } from "react";

const DarkBasicFrame: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div className="relative">
      <div
        className=" shadow-md rounded-md pointer-events-none"
        style={{
          border: '20px solid #000000c7',
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default DarkBasicFrame;
